import { del, get, post, put } from "../client";
import {
  CREATE_GIFT_CARD,
  GET_GIFT_CARDS,
  GET_GIFT_CARD_CONSUMPTION_HISTORY,
  GET_GIFT_CARD_CONSUMPTION_HISTORY_BY_CODE,
  GET_GIFT_CARD_PURCHASE_HISTORY,
  GIFT_CARD_BY_ID,
} from "../routes";

export default {
  get_gift_cards: async (page, size) => await get(GET_GIFT_CARDS(page, size)),

  get_gift_cards_purchase_history: async (page, size) =>
    await get(GET_GIFT_CARD_PURCHASE_HISTORY(page, size)),

  get_gift_cards_consumption_history: async (page, size) =>
    await get(GET_GIFT_CARD_CONSUMPTION_HISTORY(page, size)),

  get_gift_card_consumption_history_by_code: async (code) =>
    await get(GET_GIFT_CARD_CONSUMPTION_HISTORY_BY_CODE(code)),

  create_gift_card: async (data) => await post(CREATE_GIFT_CARD, data),

  get_gift_card_by_id: async (id) => await get(GIFT_CARD_BY_ID(id)),

  edit_gift_card: async (id, data) => await put(GIFT_CARD_BY_ID(id), data),

  delete_gift_card: async (id) => await del(GIFT_CARD_BY_ID(id)),
};
